export const MY_COLUMNS = 'my-columns';
export const DEFAULT_COLUMNS = 'default-columns';
export const ALL_COLUMNS = 'all-columns';
export const FAVOURITE_COLUMN_PRESET_KEY = 'favourite-column-preset';
export const COLUMN_LAYOUT = 'column-layout';
/** Prefix for named column views (visibility + order). Full key: preferenceType=ColumnView,entity=${gridId} */
export const COLUMN_VIEW_PREFERENCE_KEY_PREFIX = 'preferenceType=ColumnView,entity=';

export function getColumnViewPreferenceKey(gridId: string): string {
    return `${COLUMN_VIEW_PREFERENCE_KEY_PREFIX}${gridId}`;
}

export const PRESET_INDEX = {
    all: -1,
    default: -2,
    my: -3,
    /** A user-created saved column view is selected (see selectedSavedViewId). */
    saved: -4
};
